import { Tab, Tabs } from "@heroui/react";
import React from "react";

const CommonSegmentedTabs = ({
  selectedKey,
  onSelectionChange,
  tabs,
  variant = "solid",
  color = "secondary",
  size = "sm",
  classNames = {},
}) => {
  return (
    <Tabs
      selectedKey={selectedKey}
      onSelectionChange={onSelectionChange}
      variant={variant}
      size={size}
      color={color}
      classNames={{
        base: "flex",
        tabList: "bg-gray-200/50 dark:bg-gray-800/80 p-1 rounded-xl gap-0 border-none shadow-none",
        tab: "rounded-lg font-bold text-xs text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 transition-all duration-200 px-4 py-1.5 h-auto",
        tabContent: "font-bold text-xs flex items-center gap-2 group-data-[selected=true]:text-secondary dark:group-data-[selected=true]:text-secondary-light",
        cursor: "bg-white dark:bg-gray-900 !rounded-lg shadow-sm",
        ...classNames,
      }}
      aria-label="Segmented switcher tabs"
    >
      {tabs.map((tab) => (
        <Tab
          key={tab.key}
          title={
            <div className="flex items-center gap-2">
              {tab.icon}
              <span>{tab.title}</span>
            </div>
          }
        />
      ))}
    </Tabs>
  );
};

export default CommonSegmentedTabs;
